import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-agro-ria',
  templateUrl: './agro-ria.component.html',
  styleUrls: ['./agro-ria.component.scss', '../olx/olx.component.scss']
})
export class AgroRiaComponent {
  menuOpen = false;
  reviews = [
    { text: 'agro_page.testimonials_1_text', author: 'agro_page.testimonials_1_author' },
    { text: 'agro_page.testimonials_2_text', author: 'agro_page.testimonials_2_author' }
  ];
  toggleMenu(): void { this.menuOpen = !this.menuOpen; }
  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
    if (this.menuOpen) { this.toggleMenu(); }
  }

  protected readonly environment = environment;
}
